import { withLDConsumer } from "launchdarkly-react-client-sdk";
import React from "react";
import { Provider } from "react-redux";
import type { Store } from "redux";
import { TrackJS } from "trackjs";

import DigitalGiftCardsContainer from "containers/digital_gift_cards_container";

import type { DigitalGiftCardsStore, Flags } from "types/digital_gift_cards";

type DigitalGiftCardsAppProps = {
  store: Store<DigitalGiftCardsStore>;
  flags: Flags;
};

function DigitalGiftCardsApp({ store, flags }: DigitalGiftCardsAppProps) {
  if (!store || !store.getState()) {
    TrackJS.track("Redux store and state not initialized in app.");
    return <></>;
  }

  return (
    // @ts-expect-error Ignore Redux ts error for now
    <Provider store={store}>
      {/* @ts-expect-error Ignore Redux ts error for now */}
      <DigitalGiftCardsContainer flags={flags} />
    </Provider>
  );
}

export default withLDConsumer()(DigitalGiftCardsApp);
